import { render, staticRenderFns } from "./TabelaCalculoForm.vue?vue&type=template&id=f8496dd2&"
import script from "./TabelaCalculoForm.vue?vue&type=script&lang=js&"
export * from "./TabelaCalculoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports